import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { HeroSection } from "./components/sections/HeroSection";
import { ProblemSection } from "./components/sections/ProblemSection";
import { DeliverablesSection } from "./components/sections/DeliverablesSection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { ChallengeSection } from "./components/sections/ChallengeSection";
import { SituationsSection } from "./components/sections/SituationsSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { DifferenceSection } from "./components/sections/DifferenceSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { AuthorSection } from "./components/sections/AuthorSection";
import { FaqSection } from "./components/sections/FaqSection";
import { FinalCtaSection } from "./components/sections/FinalCtaSection";
import { FooterSection } from "./components/sections/FooterSection";
export function App() {
  return <div className="w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="7sxpp6lk59z">
      <MetaPixel data-id="element-1" data-mp="2zmwhmy3ufmc9" />
      <main data-id="element-2" data-mp="2zng2amkvootz">
        <HeroSection data-id="element-3" data-mp="33mf3bw3ho1g5" />
        <ProblemSection data-id="element-4" data-mp="33lwzoeehyky7" />
        <DeliverablesSection data-id="element-5" data-mp="33n6yx6x35z6f" />
        <BeforeAfterSection data-id="element-6" data-mp="33oi1j3esp0vy" />
        <ChallengeSection data-id="element-7" data-mp="38l8gtoirzsgb" />
        <SituationsSection data-id="element-8" data-mp="38l05w267qx7r" />
        <VolumesSection data-id="element-9" data-mp="38nuqbtp88i16" />
        <BonusesSection data-id="element-10" data-mp="3dkl42adk71jf" />
        <DifferenceSection data-id="element-11" data-mp="3dl4jnkfqldua" />
        <OfferSection data-id="element-12" data-mp="3dmfn1j59sjkv" />
        <GuaranteeSection data-id="element-13" data-mp="3dii4ozqinw21" />
        <TestimonialsSection data-id="element-14" data-mp="nw2a60hx7gog" />
        <AuthorSection data-id="element-15" data-mp="nur948fv0n11" />
        <FaqSection data-id="element-16" data-mp="nxn5vtfz15nw" />
        <FinalCtaSection data-id="element-17" data-mp="suncq6knacg2" />
      </main>
      <FooterSection data-id="element-18" data-mp="stkn01z26g1q" />
      <FloatingCta data-id="element-19" data-mp="st2hsfuf4rho" />
      <PurchasePopup data-id="element-20" data-mp="swq8z8ce51t8" />
    </div>;
}